import * as React from 'react';
import { Tooltip } from 'react-leaflet';
import { localizations } from '../localization/localization';
import { UnitProperties } from "../units/UnitModels";
import { toCommaDecimal } from '../utils/numberUtils';
import { TruckModel } from '../trucks/TruckModels';
import { momentToString, momentToTimeString } from '../utils/dateUtilities';
import { ApplicationState } from "../store";
import { connect } from 'react-redux';
import * as UnitStore from '../units/store/unitStore'
import * as TruckStore from '../trucks/store/truckStore'


interface RouteProps  { 
  units: UnitStore.FreeUnitState,
  trucks: TruckStore.TrucksState
}

const renderProperties = (properties: UnitProperties) => {
  const propertiesArray: string[] = [];

  Object.keys(properties).forEach(value => {
      if (properties[value]) {
          propertiesArray.push(localizations.units.properties[value]);
      }
  });
  return <span>{propertiesArray.join(", ")}</span>
}
const renderRoutes = (props: any) => {

  const trucks = props.trucks.routes
  let length = 0
  Object.keys(trucks).forEach((value, index) => {
      if (trucks[value].distance !== undefined && props.destinationCity !== null && trucks[value].from.id === props.departureCity.id && trucks[value].to.id === props.destinationCity.id && trucks[value].distance !== null ) {
        length =  Math.round(trucks[value].distance)
      }
  });
  return length
}
const renderPrice = (props: any) => {

  const trucks = props.trucks.routes
  let price = 0.00
  let length = 0
  Object.keys(trucks).forEach((value, index) => {
      if (props.destinationCity !== null && trucks[value].from.id === props.departureCity.id &&  trucks[value].to.id === props.destinationCity.id && trucks[value].distance !== null) {
        length = Math.round(trucks[value].distance)
        price = props.contractPrice * length
      }
  });
  if (price !== 0.00) {
      return price
  }
  else {
      return null
  }
}

function pad(num: number) {
  return ("0"+num).slice(-2);
}
function hhmmss(secs: number) {
  let minutes = Math.floor(secs / 60);
  secs = secs%60;
  const hours = Math.floor(minutes/60);
  minutes = minutes%60;
  return `${pad(hours)}:${pad(minutes)}:${pad(secs)}`;
}
function hmin(secs: number) {
  let minutes = Math.floor(secs / 60);
  secs = secs%60;
  const hours = Math.floor(minutes/60);
  minutes = minutes%60;
    
  if (hours < 1) {
    return `${minutes}${localizations.common.min}`;
  }
  return `${hours}${localizations.common.h} ${pad(minutes)}${localizations.common.min}`;
}

const renderTimeEstimate = (props: any) => {
    const trucks = props.trucks.routes
    let length = 0
    let secs = 0
    let formattedTime = ''
    Object.keys(trucks).forEach((value, index) => {
        if (props.destinationCity !== null && trucks[value].from.id === props.departureCity.id && trucks[value].to.id === props.destinationCity.id && trucks[value].distance !== null )  {
          length = Math.round(trucks[value].distance)
          secs = Math.ceil(length / 80 * 3600)
          formattedTime = hmin(secs)
        }
    });
    if (formattedTime !== '') {
        return formattedTime
    }
    else {
        return null
    }
  }

type TruckRouteProps = TruckModel & RouteProps

const mapStateToProps = (state: ApplicationState) => {
  const { units, trucks } = state;
  return { units, trucks };
}

const TruckTooltip: React.SFC<TruckRouteProps> = (props) => {


  const startTime = momentToString(props.availableFrom);
  const endTime = props.availableFrom.dayOfYear() === props.availableTo.dayOfYear()
    && props.availableFrom.year() === props.availableTo.year()
    ? momentToTimeString(props.availableTo)
    : momentToString(props.availableTo);
  const route = props.destinationCity
    ? `${props.departureCity.name} - ${props.destinationCity.name}`
    : `${props.departureCity.name}`;
  const price = props.contractPrice ? toCommaDecimal(props.contractPrice) : null;
  const properties = renderProperties(props.properties);
  const routeProperties = renderRoutes(props);
  const priceProperties = renderPrice(props);
  const timeEstimateProperties = renderTimeEstimate(props);
  return (
    <Tooltip offset={[15, -10]}>
      <div>{props.reportNumber}</div>
      <div>{`${startTime} - ${endTime}`}</div>
      <div>{route}</div>
      {properties ? <div>{properties}</div> : null}
      {price ? <div>{`${price} €/km`}</div> : null}
      {routeProperties ? <div>{`~ ${routeProperties.toFixed()} km`}</div> : null}
      {timeEstimateProperties ? <div>{`~ ${timeEstimateProperties} ${localizations.common.speedUsedForCalc}`}</div> : null}
      {priceProperties ? <div>{`~ ${priceProperties.toFixed(2)} €`}</div> : null}
    </Tooltip>
  );
}

export default connect<any, any, any>(mapStateToProps)(TruckTooltip);


// WEBPACK FOOTER //
// ./src/map/TruckTooltip.tsx